// ============================================================
// หน้า RecordOther — บันทึกรายรับอื่นๆ
// ------------------------------------------------------------
// รับเงินรายการที่ไม่ใช่ค่าน้ำ/ค่าส่วนกลางประจำเดือน แล้วออกใบเสร็จให้ทันที
//
// ขั้นตอน
//   1. ขอเลขที่ใบแจ้งหนี้ (running number รูปแบบ IW) จาก backend
//   2. เลือกบ้านเลขที่ → ระบบเติมชื่อ/หน่วยงาน/ที่อยู่ให้ (พิมพ์แก้เองได้)
//   3. เลือกวิธีชำระ — เงินโอนต้องระบุวันที่/เวลาโอน และแนบสลิปได้
//   4. เลือกรหัสรายการรับชำระ (ตั้งค่าไว้ในหน้า "รายการรับชำระ") แล้วกรอกจำนวนเงิน
//   5. กด "พิมพ์ใบเสร็จ" → บันทึก + เปิดใบเสร็จในแท็บใหม่ + ล้างฟอร์มพร้อมออกใบถัดไป
//
// ตรรกะการเตรียมข้อมูลใบเสร็จอยู่ที่ components/custom/receipt-print.js (ใช้ร่วมกับหน้ารับชำระ)
// ============================================================

import React, { Component } from "react";
import Select from "react-select";
import Resizer from "react-image-file-resizer";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { tokens, alert, select_style, toFixed, GET, POST, float, validate, DatePicker, NumberZero, getStorage, loading, permission, printReceiptByIwNumber } from "../../shared/index.js";

const perm = permission("record-other");

// วิธีการชำระเงิน
const PAYMENT_CASH = 1;
const PAYMENT_TRANSFER = 2;

export default class RecordOther extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  // ค่าเริ่มต้นของฟอร์ม (ใช้ทั้งตอนเปิดหน้าและตอนล้างฟอร์มหลังบันทึก)
  getInitialState = () => {
    const now = new Date();
    return {
      data_customer: null, // ตัวเลือกบ้านเลขที่
      data_manage: null, // ตัวเลือกรหัสรายการรับชำระ
      customer_id: "",
      address_number: null,
      record_date: now,
      record_time: `${NumberZero(now.getHours())}:${NumberZero(now.getMinutes())}`,
      iw_number: "",
      disable_button: false, // กันกดบันทึกซ้ำระหว่างรอ
      // การชำระเงิน
      payment_type: PAYMENT_CASH,
      transfer_date: "",
      transfer_time: "",
      photo: "",
      is_upload_slip: false, // บังคับแนบสลิปหรือไม่
      // ข้อมูลผู้ชำระ
      full_name: "",
      project_name: "",
      address: "",
      // รายการที่เก็บเงิน
      code: "",
      title: "",
      description: "",
      cost: "",
      total_amount: 0.0,
    };
  };

  async componentDidMount() {
    if (!perm.view) return;
    loading(true);
    await Promise.all([this.GetRunningNumber(), this.GetCustomerAll(), this.GetDocumentManageAll()]);
    loading(false);
  }

  // ---------- โหลดข้อมูล ----------

  // รหัสรายการรับชำระที่ตั้งไว้ในหน้า "รายการรับชำระ"
  GetDocumentManageAll = async () => {
    const result = await GET(tokens, "v1/TH/document-manage/pay-list/filter-search/page/0", { data_search: "" });
    if (result?.status) this.setState({ data_manage: result.data.data });
  };

  // ตัวเลือกบ้านเลขที่ (แสดงเป็น "อาคาร x ห้อง y")
  GetCustomerAll = async () => {
    const result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) {
      this.setState({ data_customer: result.data.data.map((item) => ({ value: item.customer_id, label: `อาคาร ${item.building} ห้อง ${item.address_number}`, ...item })) });
    }
  };

  // เลขที่ใบแจ้งหนี้ตัวถัดไป
  GetRunningNumber = async () => {
    const result = await GET(tokens, `v1/TH/record-receipt/running-iw/${getStorage("project_id")}`, { format_doc: "IW" });
    if (result?.status) {
      this.setState({ iw_number: result.data.data });
      // คืนเลขตรงๆ ให้ผู้เรียกใช้ทันที (ไม่พึ่ง this.state ที่ setState ยังไม่ทันอัปเดต)
      return result.data.data;
    }
    return null;
  };

  // เลขที่ใบเสร็จจริงจาก response (backend อาจออกเลขใหม่ให้ถ้าเลขที่ส่งไปชน) · ไม่มีมา = ใช้เลขที่ส่งไป
  pickIwNumber = (result, sent) => {
    const d = result?.data;
    const n = (d && typeof d === "object" ? d.iw_number : null) || result?.iw_number;
    return n ? String(n) : sent;
  };

  // ---------- บันทึก ----------

  Create = async () => {
    // กันกดรัว: flag บน instance เช็คได้ทันที ไม่รอ setState
    if (this._submitting) return;
    this._submitting = true;
    this.setState({ disable_button: true });
    loading(true);
    try {
    // ขอเลขที่ล่าสุดอีกครั้งก่อนบันทึก กันชนกับผู้ใช้คนอื่นที่บันทึกไประหว่างนั้น
    // ใช้เลขที่ได้ตรงๆ ถ้าขอไม่ได้ค่อยใช้เลขเดิมใน state
    const sent_iw_number = (await this.GetRunningNumber()) || this.state.iw_number;

    const { customer_id, record_date, record_time, payment_type, transfer_date, transfer_time, full_name, project_name, address, code, title, description, cost, total_amount, photo } = this.state;

    const data = {
      customer_id,
      record_water_list: [], // ไม่ใช่การรับชำระค่าน้ำ จึงไม่มีบิลผูก
      record_date: new Date(record_date).toISOString().split("T")[0],
      record_time,
      iw_number: sent_iw_number,
      payment_type,
      transfer_date: transfer_date || null,
      transfer_time: transfer_time || null,
      full_name,
      project_name,
      agency_name: project_name,
      address,
      address_number: "",
      sum_unit_used: 0,
      payment_list: [],
      record_other_list: [{ code, title, description, cost: Number(cost) }],
      clement_remark: "",
      total_amount,
      change_satang: 0,
      total_final: total_amount,
      add_on_add_debt: 0,
      add_on_reduce_debt: 0,
      add_on_add_debt_remark: "",
      add_on_reduce_debt_remark: "",
      photo: photo || "",
    };

    const result = await POST(tokens, `v1/TH/record-receipt/create/${getStorage("project_id")}`, data);
    if (result?.status) {
      const iw_number = this.pickIwNumber(result, sent_iw_number);
      await printReceiptByIwNumber(iw_number, this.clear_form);
      // NOTE alert() รับแค่ 3 พารามิเตอร์ ตัวที่ 4 ("/record-other") ไม่มีผล เป็นพฤติกรรมเดิม
      alert("success", "สำเร็จ", `บันทึกใบแจ้งหนี้หมายเลข "${iw_number}" สำเร็จแล้ว`, "/record-other");
      this.clear_form();
      this.GetRunningNumber();
    }
    } catch (e) {
      console.error(e);
    } finally {
      this._submitting = false;
      this.setState({ disable_button: false });
      loading(false);
    }
  };

  clear_form = () => this.setState(this.getInitialState());

  // ---------- ฟอร์ม ----------

  // เลือกบ้านเลขที่ → เติมข้อมูลผู้ชำระให้อัตโนมัติ
  onSelectCustomer = (option) => {
    this.setState({
      customer_id: option.customer_id,
      full_name: option.full_name,
      project_name: option.project_name,
      address: option.address || option.address_number,
      address_number: option,
    });
  };

  // พิมพ์แก้ข้อมูลผู้ชำระเอง = ถือว่าไม่ได้ผูกกับบ้านเลขที่ที่เลือกไว้
  handleTextChange = (field) => (e) => this.setState({ [field]: e.target.value, customer_id: "", address_number: null });

  // อัปโหลดสลิป — ย่อเป็น 720x720 แล้วเก็บเป็น base64 (เลือกได้หลายรูป)
  handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const resizedPhotos = [];
    files.forEach((file) => {
      Resizer.imageFileResizer(
        file,
        720,
        720,
        "JPG",
        100,
        0,
        (uri) => {
          resizedPhotos.push(uri.split(",")[1]);
          // ครบทุกรูปแล้วค่อย setState ทีเดียว
          if (resizedPhotos.length === files.length) this.setState({ photo: resizedPhotos });
        },
        "base64"
      );
    });
  };

  // ตรวจฟอร์มก่อนบันทึก — เงินโอนต้องมีวันที่/เวลาโอนด้วย
  onSubmit = () => {
    const required = this.state.payment_type === PAYMENT_CASH ? ["code", "title", "cost"] : ["transfer_date", "transfer_time", "code", "title", "cost"];
    if (this.state.payment_type === PAYMENT_TRANSFER && this.state.is_upload_slip && !this.state.photo.length) {
      return alert("warning", "แจ้งเตือน", "กรุณาอัพโหลดสลิปการโอนเงิน");
    }
    if (!validate(this.state, required)) this.Create();
  };

  render() {
    const { iw_number, data_customer, address_number, record_date, record_time, payment_type, transfer_date, transfer_time, full_name, project_name, address, data_manage, title, description, cost, total_amount } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="บันทึกรายรับอื่นๆ" />

        <div className="body">
          <div className="p-3">
            <div className="d-flex row mx-0 align-items-center justify-content-between">
              <h4 className="mb-3">
                <b>บันทึกรายรับอื่นๆ เลขที่ใบแจ้งหนี้ : {iw_number || "-"}</b>
              </h4>
            </div>

            {/* ข้อมูลผู้ชำระ + วิธีการชำระ */}
            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-lg-4 col-xl-3">
                  <label>บ้านเลขที่</label>
                  <Select className="form-control bg-contain border-0 select-search w-100 mb-3" styles={select_style} options={data_customer || []} value={address_number} onChange={this.onSelectCustomer} />
                </div>
                {/* วันที่/เวลา ล็อกไว้เป็นเวลาที่เปิดหน้า แก้ไม่ได้ */}
                <div className="col-6 col-lg-4 col-xl-3 mb-3">
                  <label>วันที่</label>
                  <DatePicker className="form-control bg-contain border-0" value={record_date} disabled />
                </div>
                <div className="col-6 col-lg-4 col-xl-3 mb-3">
                  <label>เวลา</label>
                  <input type="time" className="form-control w-100 bg-contain border-0" value={record_time} disabled />
                </div>

                <div className="col-12 col-lg-4 col-xl-3 mb-2">
                  <label>เลือกวิธีการชำระ</label>
                  <div className="d-flex" style={{ height: 60 }}>
                    <div className="d-flex wpx-100 align-items-center">
                      <input type="radio" checked={payment_type === PAYMENT_CASH} onChange={(e) => e.target.checked && this.setState({ payment_type: PAYMENT_CASH, transfer_date: "", transfer_time: "" })} />
                      <label className="mb-0 ml-3">เงินสด</label>
                    </div>
                    <div className="d-flex wpx-100 align-items-center">
                      <input type="radio" checked={payment_type === PAYMENT_TRANSFER} onChange={(e) => e.target.checked && this.setState({ payment_type: PAYMENT_TRANSFER, transfer_date: "", transfer_time: "" })} />
                      <label className="mb-0 ml-3">เงินโอน</label>
                    </div>
                  </div>
                </div>

                {/* ช่องเพิ่มเติมเมื่อเลือกเงินโอน */}
                {payment_type === PAYMENT_TRANSFER && (
                  <>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>วันที่โอน</label>
                      <DatePicker className="form-control bg-contain border-0" onChange={(e) => this.setState({ transfer_date: e })} value={transfer_date} />
                    </div>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>เวลาโอน</label>
                      <input type="time" className="form-control w-100 bg-contain border-0" onChange={(e) => this.setState({ transfer_time: e.target.value })} value={transfer_time} />
                    </div>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>รูปสลิปโอนเงิน</label>
                      <input type="file" accept="image/*" className="d-block w-100 border-0 pt-2 pb-0 px-2" style={{ appearance: "none", background: "none" }} multiple onChange={this.handleImageUpload} />
                    </div>
                  </>
                )}

                <div className="col-12 col-md-4 mb-3">
                  <label>ชื่อ-นามสกุล</label>
                  <input type="text" className="form-control w-100 bg-contain border-0" onChange={this.handleTextChange("full_name")} value={full_name} maxLength={100} />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ชื่อหน่วยงาน</label>
                  <input type="text" className="form-control w-100 bg-contain border-0" onChange={this.handleTextChange("project_name")} value={project_name} maxLength={200} />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ที่อยู่</label>
                  <input type="text" className="form-control w-100 bg-contain border-0" onChange={this.handleTextChange("address")} value={address} maxLength={500} />
                </div>
              </div>
            </div>

            {/* รายการที่เก็บเงิน (ครั้งละ 1 รายการ) */}
            <div className="card border-0 p-3 mb-3">
              <table className="table table-borderless table-striped">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th className="text-center wpx-120">ลำดับที่</th>
                    <th className="text-center">รายการ</th>
                    <th className="text-center">รายละเอียด</th>
                    <th className="text-right wpx-200">ราคารวมสุทธิ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {/* เลือกจากรหัสรายการ แล้วชื่อรายการจะถูกเติมให้อัตโนมัติ (แก้ไม่ได้) */}
                    <td className="text-center">
                      <Select
                        className="form-control border-0 select-search w-100 mb-3"
                        styles={select_style}
                        options={data_manage ? data_manage.map((data) => ({ value: data.title, label: data.code })) : []}
                        onChange={(e) => this.setState({ code: e.label, title: e.value })}
                      />
                    </td>
                    <td>
                      <input type="text" className="form-control" value={title} readOnly />
                    </td>
                    <td>
                      <textarea className="form-control" placeholder="รายละเอียด" onChange={(e) => this.setState({ description: e.target.value })} value={description} maxLength={2000} />
                    </td>
                    <td>
                      <input type="text" className="form-control" onChange={(e) => float(e.target.value) && this.setState({ cost: e.target.value, total_amount: Number(e.target.value) })} value={cost} maxLength={11} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="card border-0 p-3 mb-3">
              <div className="w-100 d-flex justify-content-between">
                <b>จัดเก็บเงินทั้งสิ้น</b> <b>฿{toFixed(total_amount)}</b>
              </div>
            </div>

            {perm.create && (
              <button className="btn btn-outline-primary bg-white w-100 mb-4" onClick={this.onSubmit} disabled={this.state.disable_button}>
                พิมพ์ใบเสร็จ
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
